import { Injectable } from '@angular/core';
import { Http, QueryHandlerFor, Wrapper } from '@skylab-angular-shared/core';
import { UnitQuery, UnitQueryHandlerBase } from '@skylab-shared/business';

@Injectable({ providedIn: 'root'})
@QueryHandlerFor(UnitQuery)
@Wrapper(UnitQueryHandlerBase)
export class UnitQueryHandler {
    public constructor(
        http: Http
    ) { }
}
